module.exports = directory;